import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { __publicField } from "./chunk-NHABU752.mjs";

// src/modal-manager.ts
import { useEffect, useState } from "react";
var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);
    __publicField(this, "modals");
    this.modals = /* @__PURE__ */new Map();
  }
  _createClass(ModalManager, [{
    key: "add",
    value: function add(modal) {
      this.modals.set(modal, this.modals.size + 1);
      return this.modals.size;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      this.modals.delete(modal);
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      if (!modal) return false;
      return this.modals.get(modal) === this.modals.size;
    }
  }]);
  return ModalManager;
}();
var manager = new ModalManager();
function useModalManager(ref, isOpen) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (isOpen) {
      var index2 = manager.add(node);
      setIndex(index2);
    }
    return function () {
      manager.remove(node);
      setIndex(0);
    };
  }, [isOpen, ref]);
  return index;
}
export { manager, useModalManager };